(ns common.schema.entities.esign-process.schema
  (:require
   [common.schema.entities.common :as common]
   [common.schema.schema-utils :as su]
   [common.schema.entities.related-entities :as related-entities]
   [common.schema.entities.esign-process-status :as esign-process-status]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (concat
   (su/keyword-field :esign-process/status
                     "Status"
                     esign-process-status/status-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})
   (su/keyword-field :esign-process/provider
                     "Provider"
                     [{:key   :oneflow ;; :esign-process.provider/oneflow
                       :label "Oneflow"}
                      {:key   :docusign ;; :esign-process.provider/docusign
                       :label "Docusign"}]
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})
   (su/single-ref-field :esign-process/target
                        "Target"
                        [:entity.type/kyc-process]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})
   (su/multi-ref-field :esign-process/signatories
                       "Signatories"
                       [:entity.type/signatory]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})
   (su/text-simple-field :esign-process/oneflow-document-id
                         "Oneflow document id"
                         (system-controlled {:authorization            su/access-system-user
                                             :default-field-visibility :in-use}))
   (su/text-simple-field :esign-process/docusign-envelope-id
                         "DocuSign envelope id"
                         (system-controlled {:authorization            su/access-system-user
                                             :default-field-visibility :in-use-disabled}))

   (su/boolean-field :esign-process/esign-v2?
                     "E-sign v2?"
                     (system-controlled {:authorization            su/access-system-user
                                         :default-field-visibility :in-use-disabled}))

   (su/datetime-field :esign-process/failed-at
                      "Failed at time"
                      (system-controlled {:authorization            su/access-system-user
                                          :default-field-visibility :in-use-disabled}))

   (su/keyword-field :esign-process/fail-reason
                     "Fail reason"
                     nil
                     (system-controlled {:authorization            su/access-system-user
                                         :default-field-visibility :in-use-disabled}))

   (su/datetime-field :esign-process/last-synced-on
                      "Last synced on"
                      (system-controlled {:authorization            su/access-system-user
                                          :default-field-visibility :in-use-disabled}))

   (su/datetime-field :esign-process/polling-rate-limit-reset-on
                      "Polling rate limit reset on"
                      (system-controlled {:authorization            su/access-system-system
                                          :editor-type              :editor.type/none
                                          :grid-type                :editor.type/none
                                          :filter-type              :filter.type/none
                                          :default-field-visibility :in-use}))

   related-entities/related-entities
   common/attachment-schema))
